import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Langs from './pages/Langs';
import Slides from './pages/Slides';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Partners from './pages/Partners';
import Contact from './pages/Contact';
import Login from './pages/Login';
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                    <Route index element={<Dashboard />} />
                    <Route path="langs" element={<Langs />} />
                    <Route path="slides" element={<Slides />} />
                    <Route path="services" element={<Services />} />
                    <Route path="portfolio" element={<Portfolio />} />
                    <Route path="about" element={<About />} />
                    <Route path="partners" element={<Partners />} />
                    <Route path="contact" element={<Contact />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
